import {
    GHGEmissionsReportSettings,
    useFiltersApi,
    useFiltersStore,
} from '@/hooks'
import { SustainabilityFiltersValues } from '@/utils/constants'
import { useMemo } from 'react'
import { mapSustainabilityFiltersGetParams } from '../utils/mapSustainabilityFiltersGetParams'

export const useGHGEmissionsFiltersGetParams = (
    activeSustainabilityFilters: SustainabilityFiltersValues,
    reportSettings: GHGEmissionsReportSettings
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    const { useCommoditiesQuery } = useFiltersApi()
    const { data: commodities } = useCommoditiesQuery({
        'nodeIds[]': rootNode?.nodeId.toString(),
    })

    const sustainabilityFiltersParams = useMemo(() => {
        const passedFilters = Object.assign({}, activeSustainabilityFilters)
        const { scope, scope2type } = reportSettings

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        if (!passedFilters.commodity.length && commodities) {
            passedFilters.commodity = commodities.map(
                (commodity) => commodity.commodityTypeId
            )
        }

        passedFilters.meter = [] // GHG Emissions report doesn't support meter filter

        const params = mapSustainabilityFiltersGetParams(passedFilters)

        return {
            'nodeIds[]': params['nodeIds[]'] ?? '',
            ...params,
            scope,
            scope2type,
            includeTotals: reportSettings.showTotals,
        }
    }, [activeSustainabilityFilters, commodities, reportSettings, rootNode])

    return sustainabilityFiltersParams
}
